import { useState, useEffect } from "react";
import styled from "styled-components";
import { useTheme } from "@mui/material";

const Gradient = styled.div`
    position: absolute;
    top: ${(props) => (props.topMode ? "-79px" : "auto")};
    bottom: ${(props) => (props.topMode ? "auto" : "-1px")};
    left: 0;
    right: 15px;
    height: 80px;
    background: ${(props) =>
        props.darkMode
            ? "linear-gradient(180deg, rgba(35, 35, 35, 0), #232323)"
            : "linear-gradient(180deg, rgba(255, 255, 255, 0), #FFFFFF)"};
    z-index: 2;
    pointer-events: none;
`;

export default function GradientOverlay({ scrollRef, topMode }) {
    const theme = useTheme();
    const [hideGradientOverlay, setHideGradientOverlay] = useState(false);

    const handleScroll = () => {
        setHideGradientOverlay(
            scrollRef.current.scrollHeight - scrollRef.current.scrollTop <=
                scrollRef.current.clientHeight + 1,
        );
    };

    useEffect(() => {
        const scroll = scrollRef.current;
        if (!scroll) {
            return;
        }

        scroll.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            scroll.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return hideGradientOverlay ? null : (
        <Gradient darkMode={theme.palette.mode == "dark"} topMode={topMode} />
    );
}
